import React from "react";
import { useAtom } from "jotai";
import { gbState } from "../../components/shared/GlobalState";

import MainTemplate from "../../components/MainTemplate/MainTemplate";

import CenterStageSection from "./CenterStageSection";

const ChurchOnBoardMenu = () => {
  return (
    <MainTemplate>
      <CenterStageSection />
    </MainTemplate>
  );
};

export default ChurchOnBoardMenu;
